import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import logoUrl from '../assets/new_logo_4_no_words_white_bg.png';
import { processLogoToWhiteOnTransparent } from '../utils/logoProcessing';

export default function BrandLogo({ className = 'h-10 w-auto', alt = 'מי פנוי' }) {
  const [processedSrc, setProcessedSrc] = useState(null);

  useEffect(() => {
    let mounted = true;
    processLogoToWhiteOnTransparent(logoUrl).then((dataUrl) => {
      if (mounted) setProcessedSrc(dataUrl);
    });
    return () => {
      mounted = false;
    };
  }, []);

  // Fallback to original while processing
  const src = processedSrc || logoUrl;

  return (
    <Link 
      to="/" 
      aria-label="דף הבית"
      onClick={() => window.scrollTo({ top: 0, left: 0, behavior: 'auto' })}
      className="focus:outline-none focus-visible:ring-2 focus-visible:ring-orange-300 focus-visible:ring-offset-0 rounded"
    >
      <img src={src} alt={alt} className={className} decoding="async" loading="eager" />
    </Link>
  );
}


